import React, { Fragment } from 'react'
import { Divider, Grid } from '@mui/material'
import { Formik, Form } from 'formik'
import { Courier } from '../../../interfaces/Courier'
import * as Yup from 'yup'
import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { CreateCourierService } from './CreateCourierService'
import { UpdateCourier } from './UpdateCourier'
import { ModifyCourierServices } from './UpdateCourierServices'
import { Loading } from '../../../components/UI'
import { useSnackbar } from '../../../hooks/useSnackbar'
import { SnackBar } from '../../../components/SnackBar/Snackbar'

interface CourierFormEditProps {
  courierId: number
  handleSnackbar: (msg: string | undefined, status: boolean) => void
}

const getCourier = (courierId: number) => {
  const url = new URL(`${ApiConfig.CourierApi}/${courierId}`)

  return axios.get(url.toString())
}

export const CourierFormEdit: React.FC<CourierFormEditProps> = ({
  courierId,
  handleSnackbar
}) => {
  const [loading, setLoading] = React.useState(false)

  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()

  const { state, callApi } = useApi<Courier>()

  const requestCourier = () => {
    setLoading(true)
    callApi(getCourier(courierId))
      .then((response: Courier) => setInitialValues(response))
      .catch((err) => handleSnackbar(err, false))
      .finally(() => setLoading(false))
  }

  const [initialValues, setInitialValues] = React.useState<Courier>({
    courierId: 0,
    name: '',
    courierServices: [],
    createdAt: new Date(Date.UTC.toString()),
    hasPriorization: false
  })

  React.useEffect(() => {
    requestCourier()
  }, [])

  const validationSchema = Yup.object({
    name: Yup.string().required('Required')
    // Agrega aquí más validaciones según sea necesario
  })

  const requestUpdateCourier = (values: Courier) => {
    alert(values)
  }

  if (loading || state.status === Status.Loading) return <Loading />

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={requestUpdateCourier}
      >
        {(formProps) => (
          <Form>
            <Grid container spacing={2} direction='row'>
              <Grid item xs={12}>
                <UpdateCourier
                  handleSnackbar={handleSnackbar}
                  courier={initialValues}
                  getServices={requestCourier}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <CreateCourierService
                  courierId={courierId}
                  getServices={requestCourier}
                  notify={openSnackBar}
                />
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
            </Grid>
            <ModifyCourierServices
              data={formProps}
              getServices={requestCourier}
              notify={openSnackBar}
            />
          </Form>
        )}
      </Formik>

      <SnackBar
        message={message}
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
      />
    </Fragment>
  )
}
